export const CATEGORIES = {
  actualitate: {
    label: 'Actualitate',
    matches: ['actualitate', 'stiri', 'sociale', 'social', 'societate', 'justitie', 'juridic', 'crima', 'crime', 'educatie', 'invatamant', 'scoli', 'evenimente'],
    titleKeywords: ['dosar', 'arest', 'condamnat', 'protest', 'greva', 'tribunal', 'procuror', 'judecator']
  },
  politica: {
    label: 'Politică',
    matches: ['politica', 'politic'],
    titleKeywords: ['guvern', 'parlament', 'ministru', 'premier', 'presedinte', 'lege', 'vot', 'alegeri', 'partid', 'PSD', 'PNL', 'USR', 'DNA']
  },
  externe: {
    label: 'Externe',
    matches: ['externe', 'international', 'internationala', 'mapamond', 'lume', 'glob'],
    titleKeywords: ['razboi', 'NATO', 'UE', 'Europa', 'SUA', 'America', 'Rusia', 'China', 'Ucraina', 'Israel', 'Gaza', 'Iran', 'Putin', 'Trump', 'Biden', 'ONU', 'tratat', 'sanctiuni', 'ambasador', 'diplomatic']
  },
  economie: {
    label: 'Economie',
    matches: ['economie', 'economic', 'finante', 'afaceri', 'business', 'piata', 'bani'],
    titleKeywords: ['PIB', 'inflatie', 'BNR', 'curs', 'euro', 'dolar', 'buget', 'taxe', 'impozit', 'salariu', 'pensie', 'somaj', 'investitie', 'actiuni', 'bursa', 'banca', 'credit', 'datorie', 'deficit', 'export', 'import', 'profit', 'faliment']
  },
  sanatate: {
    label: 'Sănătate',
    matches: ['sanatate', 'medical', 'medicina', 'sanatatea', 'sanatate'],
    titleKeywords: ['spital', 'medic', 'doctor', 'vaccin', 'boala', 'virus', 'cancer', 'tratament', 'pacient', 'sanatate', 'epidemie', 'pandemie', 'OMS', 'farmacie', 'medicament', 'chirurgie', 'diagnostic']
  },
  sport: {
    label: 'Sport',
    matches: ['sport', 'fotbal', 'tenis', 'atletism', 'basket', 'baschet', 'rugby'],
    titleKeywords: ['meci', 'gol', 'victorie', 'infrangere', 'campionat', 'liga', 'turneu', 'olimpic', 'jucator', 'antrenor', 'transfer', 'FCSB', 'CFR', 'Dinamo', 'Rapid', 'Halep', 'Mutu', 'Hagi', 'nationala', 'FIFA', 'UEFA', 'Champions League']
  },
  cultura: {
    label: 'Cultură',
    matches: ['cultura', 'life', 'lifestyle', 'entertainment', 'divers', 'film', 'muzica', 'arte', 'teatru'],
    titleKeywords: ['film', 'serial', 'muzica', 'concert', 'carte', 'roman', 'expozitie', 'teatru', 'actor', 'regizor', 'premiera', 'festival', 'Oscar', 'Grammy', 'Netflix', 'HBO', 'spectacol', 'artist', 'cantaret', 'trupa']
  },
  tech: {
    label: 'Tech & Știință',
    matches: ['tech', 'tech-science', 'tehnologie', 'stiinta', 'science', 'digital', 'it', 'inovatie'],
    titleKeywords: ['AI', 'inteligenta artificiala', 'robot', 'iPhone', 'Android', 'Google', 'Apple', 'Microsoft', 'Meta', 'Facebook', 'Samsung', 'Tesla', 'SpaceX', 'satelit', 'racheta', 'spatiu', 'internet', 'cybersecurity', 'hack', 'software', 'aplicatie', 'startup', 'electric', 'baterie', 'energie']
  },
  auto: {
    label: 'Auto',
    matches: ['auto', 'masini', 'automobile', 'motoare'],
    titleKeywords: ['masina', 'autoturism', 'vehicul', 'motor', 'BMW', 'Mercedes', 'Volkswagen', 'Dacia', 'Renault', 'Ford', 'Toyota', 'hibrid', 'combustibil', 'benzina', 'motorina', 'sofer', 'permis', 'accident', 'trafic', 'autostrada', 'RAR', 'ITP', 'Rabla', 'leasing']
  },
};

export function normalizeStr(str) {
  return str.toLowerCase().trim()
    .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9\s-]/g, '');
}

export function resolveCategories(rawCategory, url, title) {
  const found = new Set();

  const primaryRaw = rawCategory || categoryFromUrl(url);
  if (primaryRaw) {
    const normalized = normalizeStr(primaryRaw);
    for (const [key, cat] of Object.entries(CATEGORIES)) {
      if (cat.matches.some(m => normalized.includes(normalizeStr(m)))) {
        found.add(key);
      }
    }
  }

  if (title) {
    const normalizedTitle = normalizeStr(title);
    for (const [key, cat] of Object.entries(CATEGORIES)) {
      if (cat.titleKeywords && cat.titleKeywords.some(kw => {
        const normalizedKw = normalizeStr(kw);
        const regex = new RegExp('(^|\s|[^a-z0-9])' + normalizedKw + '($|\s|[^a-z0-9])', 'i');
        return regex.test(normalizedTitle);
      })) {
        found.add(key);
      }
    }
  }

  return found.size > 0 ? Array.from(found) : null;
}

export function categoryFromUrl(url) {
  if (!url) return null;
  try {
    const path = new URL(url).pathname;
    const parts = path.split('/').filter(Boolean);
    if (parts[0] === 'stiri' && parts.length > 1) {
      const candidate = parts[1];
      // If it's a short segment with no article ID, it's a real category
      if (candidate && candidate.length < 30 && !candidate.match(/\d{5,}/)) return candidate;
      // Otherwise it's /stiri/slug — fall back to actualitate for digi24
      return 'actualitate';
    }
    const candidate = parts[0];
    if (candidate && candidate.length < 30 && !candidate.match(/\d{5,}/)) return candidate;
  } catch {}
  return null;
}
